import React from 'react';
import { Globe, User, MessageCircle, Mail, Phone, Wifi, FileText } from 'lucide-react';

const QRTypeSelector = ({ selectedType, onTypeChange }) => {
  const qrTypes = [
    {
      id: 'url',
      name: 'Website URL',
      description: 'Link to any website',
      icon: Globe,
      color: 'bg-blue-100 text-blue-600'
    },
    {
      id: 'vcard',
      name: 'Contact Card',
      description: 'Share contact information',
      icon: User,
      color: 'bg-green-100 text-green-600'
    },
    {
      id: 'whatsapp',
      name: 'WhatsApp',
      description: 'Direct WhatsApp message',
      icon: MessageCircle,
      color: 'bg-green-100 text-green-600'
    },
    {
      id: 'email',
      name: 'Email',
      description: 'Send email with subject',
      icon: Mail,
      color: 'bg-red-100 text-red-600'
    },
    {
      id: 'phone',
      name: 'Phone Call',
      description: 'Direct phone call',
      icon: Phone,
      color: 'bg-purple-100 text-purple-600'
    },
    {
      id: 'wifi',
      name: 'Wi-Fi Network',
      description: 'Connect to WiFi',
      icon: Wifi,
      color: 'bg-indigo-100 text-indigo-600'
    },
    {
      id: 'text',
      name: 'Plain Text',
      description: 'Display text message',
      icon: FileText,
      color: 'bg-gray-100 text-gray-600'
    },
    {
      id: 'sms',
      name: 'SMS Message',
      description: 'Send SMS with text',
      icon: MessageCircle,
      color: 'bg-yellow-100 text-yellow-600'
    }
  ];

  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">QR Code Type</h3>
      <div className="grid grid-cols-2 gap-3">
        {qrTypes?.map((type) => {
          const IconComponent = type?.icon;
          const isSelected = selectedType === type?.id;
          
          return (
            <button
              key={type?.id}
              onClick={() => onTypeChange?.(type?.id)}
              className={`
                p-4 rounded-lg border-2 transition-all duration-200 text-left
                ${isSelected 
                  ? 'border-blue-500 bg-blue-50 shadow-md' 
                  : 'border-gray-200 hover:border-gray-300 bg-white hover:bg-gray-50'
                }
              `}
            >
              <div className="flex items-start space-x-3">
                <div className={`p-2 rounded-lg ${type?.color} flex-shrink-0`}>
                  <IconComponent className="w-5 h-5" />
                </div>
                <div className="min-w-0 flex-1">
                  <h4 className="font-medium text-gray-900 text-sm">{type?.name}</h4>
                  <p className="text-xs text-gray-600 mt-1 line-clamp-2">{type?.description}</p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QRTypeSelector;